import { memo, useEffect, useRef, type FC } from 'react'
import { useParams } from 'next/navigation'
import styled from 'styled-components'
import type { TypeCmsProjectCard, TypeLang } from '@/schema'
import { getP18, imgVariants, mq, vw } from '@/styles'
import { Img, Link } from './commons'
import { motion, useAnimation, useInView } from 'motion/react'

type Props = {
  data: TypeCmsProjectCard
  categoriesNames?: string
  isRelated?: boolean
}

export const CardProject: FC<Props> = memo(({ data, categoriesNames, isRelated = false }) => {
  const { lang }:{ lang:TypeLang } = useParams()
  const { name, medium, slug } = data
  const controls = useAnimation()
  const ref = useRef(null)
  const isInView = useInView(ref, { margin: '0px 0px -100px 0px' })

  useEffect(() => {
    if(isInView) {
      controls.start('animate')
    }
  }, [controls, isInView])


  return (
    <Article ref={ref}>
      <Link href={`/project/${slug?.[lang]}`} rel='bookmark'>
        <DivCardImgWrapper className='img-wrapper' variants={imgVariants} animate={'animate'} initial={'initial'} $isRelated={isRelated}>
          <Img media={medium.image} sizes='(max-width: 768px) 90vw, 50vw'/>
        </DivCardImgWrapper>
        <hgroup>
          <h3>{name}</h3>
          {categoriesNames && <p>{categoriesNames}</p>}
        </hgroup>
      </Link>
    </Article>
  )
})

const Article = styled.article`
  h3 {
    ${getP18()}
  }

  p {
    ${getP18()}
    opacity: .4;
    text-align: center;
  }

  a {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    &:hover {
      img {
        transform: scale(1.1);
      }
    }
  }
`

const DivCardImgWrapper = styled(motion.div)<{ $isRelated: boolean }>`
  background-color: var(--color-img-placeholder);
  height: ${vw(214, 'mobile')};
  /* height: ${vw(195, 'mobile')}; */
  overflow: hidden;
  width: ${({ $isRelated }) => !$isRelated ? vw(172 ,'mobile') : '100%'};

  ${mq.greaterThan('nexus7')} {
    height: ${vw(214, 'tablet')};
    /* height: ${vw(195, 'tablet')}; */
    width: ${({ $isRelated }) => !$isRelated ? vw(172 ,'tablet') : '100%'};
  }

  ${mq.greaterThan('tablet')} {
    height: ${vw(396, 'desktop')};
    width: ${({ $isRelated }) => !$isRelated ? vw(320 ,'desktop') : '100%'};
  }

  ${mq.greaterThan('desktop')} {
    height: 396px;
    width: ${({ $isRelated }) => !$isRelated ? '320px' : '100%'};
  }

  img {
    height: 100%;
    object-fit: cover;
    transition: 1000ms transform var(--transition-ease);
    width: 100%;
  }
`

